import { CustomerTypesInversedKeys } from '@teinor/erp/types/company/customer/customerTypes'
import { ButtonPrimary, ButtonSecondary } from '../../../baseComponents/Button'
import TwinTrans from '../../../baseComponents/TwinTrans'
import { SetEditDeleteModalTy, UseEditDeleteModalProps } from '../../../utils/hooks/useEditDeleteModal'
import ModalImportCustomers from './ModalImportCustomers'
import PermissionChecker from '../../../baseComponents/PermissionChecker'
import TwinIcon from '../../../baseComponents/TwinIcon'
import { faPlus } from '@fortawesome/pro-light-svg-icons'
import { BaseScreenPageData } from '../../../baseComponents/TwinTable/BaseScreenTable/types'
import { ComponentWithPermissions } from '../../../baseComponents/CreateRoutering/types'

interface RightHeaderTableCustomersProps extends ComponentWithPermissions {
    pageData: BaseScreenPageData
    openModal: UseEditDeleteModalProps
    setOpenModal: SetEditDeleteModalTy
    updateTableInstance: () => void
    typeCustomer?: CustomerTypesInversedKeys
}

const RightHeaderTableCustomers: React.FC<RightHeaderTableCustomersProps> = ({ updateTableInstance, openModal, typeCustomer, setOpenModal, pageData, userPermissions }) => {
    return (
        <div className='flex items-center'>
            <ButtonSecondary className='mr-10' onClick={()=>{setOpenModal({type: 'edit', allRowData: {}})}}><TwinTrans transKey='importCustomer'>Importar clientes</TwinTrans></ButtonSecondary>
            {openModal?.type === 'edit' ? <ModalImportCustomers onSubmit={updateTableInstance} allRowData={openModal.allRowData} {...{ setOpened: () => setOpenModal(null), typeCustomer }} /> : null}
            <PermissionChecker userPermissions={userPermissions} permission='create'>
                {pageData.newText && <ButtonPrimary onClick={() => setOpenModal({ type: 'create', allRowData: {} })}>
                    <TwinIcon icon={faPlus} className='mr-8' />
                    {pageData.newText}
                </ButtonPrimary>}
            </PermissionChecker>
        </div>
    )
}

export default RightHeaderTableCustomers